import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";
import MainCard from "components/layout/MainCard/MainCard";
import LoadingWrapper from "components/Loading/LoadingWrapper";
import useAPI from "hooks/useAPI";
import { GlobalQueries } from "hooks/useRefreshQuery";
import icons from "helpers/icons";
import SidebarHeader from "components/layout/WithFixedSidebar/SidebarHeader/SidebarHeader";
import styles from "./SalesPage.module.scss";

const SalesPage = () => {
    const { t } = useTranslation();
    const api = useAPI();
    const { data: sales, isLoading } = useQuery([GlobalQueries.Sales], () => api.get("/sales-officer"));

    return (
        <MainCard>
            <SidebarHeader title={t("global-header-sale-title")} icon={icons.suitcase} mobileOnly />
            <div className={styles.page}>
                <header className={styles.header}>
                    <img src={icons.suitcase} alt="" />
                    <h1>{t("global-header-sale-title")}</h1>
                </header>
                <LoadingWrapper isLoading={isLoading}>
                    {sales?.length ? (
                        <div className={styles.list}>
                            {sales.map((person, index) => (
                                <article className={styles.person} key={person.id ?? person.email ?? index}>
                                    <h2>{person.first_name} {person.last_name}</h2>
                                    {person.phone && <a href={`tel:${person.phone}`}>{person.phone}</a>}
                                    {person.email && <a href={`mailto:${person.email}`}>{person.email}</a>}
                                </article>
                            ))}
                        </div>
                    ) : (
                        <p className={styles.empty}>{t("global-header-sale-messages-no_sales_assigned")}</p>
                    )}
                </LoadingWrapper>
            </div>
        </MainCard>
    );
};

export default SalesPage;
